var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('the-breadcrumbs'),_c('page-content',{attrs:{"page-title":"Video bearbeiten"}},[_c('video-form',{attrs:{"loading":_vm.loading,"video":_vm.video,"form-submitted":_vm.saveVideo,"mode":"edit"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }